import React from "react";
import PropTypes from "prop-types";
import NoImageFound from "./images/no-image-found.svg";
import NoImageFoundRevamp from "./images/no-image-found-revamp.svg";

const NoCarImageFound = ({defaultImage}) => {
    return <img src={defaultImage || NoImageFound} className={"img-fluid w-100"} alt="No Image Found" />;
};

export const NoCarImageFoundPath = NoImageFound;
export const NoCarImageFoundPathRevamp = NoImageFoundRevamp;

NoCarImageFound.propTypes = {
    defaultImage: PropTypes.string
};

export default NoCarImageFound;
